import { viewport } from '../../utils/viewport';
import { loadChartScript } from '../../utils/scripts';

document.addEventListener('alpine:init', () => {
  Alpine.data('ecommerceBoxedItems', () => ({
    init() {
      this.$nextTick(() => {
        this.$root.querySelectorAll('.ecommerce-boxed-items__box').forEach((box) => {
          new EcommerceBoxedItemsChart(box);

          // Initialize the dynamic block preview (editor)
          if (window.acf) {
            window.acf.addAction('render_block_preview', ($block, attributes) => {
              $block.find('.ecommerce-boxed-items__box').each((i, el) => new EcommerceBoxedItemsChart(el, attributes));
            });
          }
        });
      });
    },
  }));
});

class EcommerceBoxedItemsChart {
  constructor(el) {
    this.el = el;
    this.canvas = el.querySelector('canvas');
    this.ctx = this.canvas.getContext('2d');
    this.percent = +this.canvas.dataset.value.replace(/[^0-9]/g, '');
    this.data = [
      { label: '', value: this.percent },
      { label: '', value: 100 - this.percent },
    ];
    this.palette = ['rgb(38, 116, 224)', 'rgb(230, 230, 230)'];

    loadChartScript().then(() => {
      viewport.observe(this.el, () => {
        if (!this.chart) {
          this.chart = new Chart(this.ctx, this.getOptions());
        }
      });
    });
  }

  getOptions() {
    return {
      type: 'doughnut',
      data: {
        labels: this.data.map((item) => item.label),
        datasets: [
          {
            data: this.data.map((item) => item.value),
            backgroundColor: this.palette,
            hoverBackgroundColor: this.palette,
          },
        ],
      },
      options: {
        datasets: {
          doughnut: {
            cutout: '56%',
            hoverBorderWidth: 0,
            hoverOffset: 0,
            offset: 0,
            borderRadius: 6,
          },
        },
        animation: {
          animateScale: true,
        },
        plugins: {
          legend: {
            display: false,
          },
        },
      },
    };
  }
}